<template>
  <div class="header">
    <div class="content-w">
      <div class="header-logo">
        <a href="https://zhaopin.4sjob.com/" title="方阵官网"
        ><img alt="方阵官网" src="../../../../static/assist/logo.png"
        ></a>
      </div>
      <ul class="header-menu">
        <li>
          <a
            v-show="$route.path.indexOf('register') === -1"
            href="https://zhaopin.4sjob.com/"
          >首页</a
          >
        </li>
        <li v-show="$route.path.indexOf('register') > -1" class="register">
          用户注册
        </li>
        <li v-show="$route.path.indexOf('register') === -1">
          <a href="https://zhaopin.4sjob.com/jobFair">招聘会</a>
        </li>
        <!-- <li v-show="$route.path.indexOf('register') === -1">
          <a href="http://www.shebaojin.cn/" target="_blank">人事代理</a>
        </li>
        <li v-show="$route.path.indexOf('register') === -1">
          <a href="http://www.shebaojin.cn/byshd.html" target="_blank"
            >户档查询</a
          >
        </li>
        <li v-show="$route.path.indexOf('register') === -1">
          <a href="http://www.hbccp.org/" target="_blank">党员之家</a>
        </li> -->
      </ul>
      <div class="header-user">
        <div v-if="$route.path.indexOf('register') === -1" class="hu-noLogin">
          <div class="hu-item">
            <a href="https://hrim.4sjob.com/assist/login"
            ><i class="icon_gr"/>个人登录</a
            ><i class="icon-mf"/>
          </div>
        </div>
        <span v-else class="toLogin">
          已经有账号，<a
            href="javascript:;"
            class="flag"
            @click="$router.push('/assist/login')"
          >去登录<i class="el-icon-arrow-right"/></a
        ></span>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
export default {}
</script>

<style type="text/scss" lang="scss">
.content-w {
  width: 1200px;
  margin: 0 auto;
  position: relative;

  a {
    color: #333;

    &:hover {
      color: #409eff;
    }
  }
}
.header {
  height: 72px;
  background: #fff;

  &-logo {
    width: 160px;
    float: left;

    a {
      padding: 10px 0;
      display: block;
      height: 100%;
      overflow: hidden;
    }

    img {
      display: block;
    }
  }

  &-menu {
    padding-top: 20px;
    vertical-align: middle;
    position: relative;
    li {
      display: inline-block;
      padding: 0 10px;
      a {
        line-height: 32px;
        display: block;
        padding: 0 20px;
        font-size: 16px;
      }
    }
    .register {
      line-height: 52px;
      vertical-align: middle;
    }
    .register::before {
      content: "";
      position: absolute;
      left: 170px;
      height: 15px;
      background: #aaa;
      width: 2px;
      //20+52-15 37/2 18.5
      top: 38.5px;
    }
  }

  &-user {
    position: absolute;
    right: 0;
    top: 20px;
    .icon_gr {
      width: 20px;
      height: 20px;
      display: inline-block;
      margin: -2px 5px 0 0;
      vertical-align: middle;
      background: url("../../../../static/assist/icon_gr.jpg") no-repeat center;
    }
    .toLogin {
      color: #666;
      font-weight: 700;
      font-size: 14px;
      .flag {
        color: #409eff;
      }
    }
    .icon-mf {
      background: url("../../../../static/assist/icon_mf.png") no-repeat center;
      width: 38px;
      height: 20px;
      display: inline-block;
      vertical-align: middle;
      margin: -2px 0 0 3px;
      animation: shaking 0.8s ease-out infinite;
    }

    .hu-noLogin {
      height: 32px;
      line-height: 32px;
      vertical-align: middle;

      .hu-item {
        display: inline-block;
        margin-right: 30px;

        &:last-child {
          margin-right: 0;
        }

        a {
          font-size: 14px;
          vertical-align: middle;
          display: inline-block;
        }
      }
    }
  }
}

@keyframes shaking {
  0%,
  100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(4px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/assist/head/index.vue